import { type ReactElement } from 'react';
import { EmptyState } from './empty-state';

interface NoFilterResultsProps {
  title: string;
  body: string;
  buttonText?: string;
  buttonId?: string;
  onClearFilters: () => void;
  showAction?: boolean;
}

export const NoFilterResults = ({
  title,
  body,
  buttonText = 'Clear filters',
  buttonId,
  onClearFilters,
  showAction = true,
}: NoFilterResultsProps): ReactElement => (
  <EmptyState
    title={title}
    body={body}
    buttonText={buttonText}
    buttonId={buttonId}
    buttonIcon={false}
    onAction={showAction ? onClearFilters : undefined}
  />
);
